import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store/store'
import { checkUnsupportedBrowser } from '@/common/utils'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['user/isAuthenticated']
  const isRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLogin = to.fullPath === '/login'
  const isVerify = to.fullPath === '/verify'
  const storageToken = localStorage.getItem('token')
  const hasToken = storageToken || to.query.token

  if (checkUnsupportedBrowser() && to.fullPath !== '/unsupported-browser') {
    next({
      path: '/unsupported-browser',
    })
  }

  if (to.query.token && isAuthenticated) {
    await store.dispatch('user/expireToken').then(() => {
      next({
        path: '/verify',
        query: {
          token: to.query.token,
          cId: to.query.cId,
          src: to.query.cId ? 'agent' : undefined,
          redirect: '/',
        },
      })
    })
  } else if (isRequiresAuth && !isAuthenticated) {
    if (hasToken && !isVerify) {
      next({
        path: '/verify',
        query: {
          token: to.query.token,
          cId: to.query.cId,
          src: to.query.cId ? 'agent' : undefined,
          redirect: '/',
          flow: to.query.flow,
          to: to.fullPath,
        },
      })
    } else if (!to.query.token) {
      next({
        path: '/login',
        query: {
          redirect: isLogin ? '/' : to.fullPath,
        },
      })
    }
  } else {
    next()
  }
})

export default router
